import React from 'react';
import Pane from "../../Components/Pane";
import SecondaryTitle from "../../Components/SecondaryTitle";
import Loader from "../../Components/Loader";

const LoadingPage = (props) => {
    return (
        <Pane style={{width: '100%'}}>
            <SecondaryTitle style={{textAlign: 'center'}}>Loading</SecondaryTitle>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Loader />
            </div>
        </Pane>
    );
}

export default LoadingPage;
